import React from 'react';
import createSVG from './createSVG';

const ImportIconHuge = ({style}) => (
   <path style={style} d="M83.58 113.2H17V4h155.06v109.2h-66.6M94.54 67.7V186m0-118.3l26.24 21.84M94.53 67.7L68.3 89.54" stroke="#6ED2A0" strokeWidth="2.5" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"/>
);

export default createSVG(ImportIconHuge);
